import React from "react";

const CloseIcon = ({ width = "27.057", height = "27.057" }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 27.057 27.057"
      >
        <g
          id="Group_95"
          data-name="Group 95"
          transform="translate(-126.915 -50.943)"
        >
          <path
            id="Path_128"
            data-name="Path 128"
            d="M0,0,35.618.037l0,2.606L0,2.606Z"
            transform="translate(128.784 50.943) rotate(45)"
          />
          <path
            id="Path_129"
            data-name="Path 129"
            d="M0,0,35.618-.037l0,2.606L0,2.606Z"
            transform="translate(126.943 76.155) rotate(-45)"
          />
        </g>
      </svg>
    </>
  );
};
export default CloseIcon;
